import * as React from "react";
import * as equal from "fast-deep-equal";
// @ts-ignore
import * as groupBy from "group-array";

import { Hint, Suit, SuitedNumber } from "../common";
import { Card, Size } from "./Card";

interface Props {
  cards: SuitedNumber[];
}

interface State {
  played: SuitedNumber[];
  hinted: [SuitedNumber, Hint] | null;
}

export class Hand extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      played: [],
      //played: [new SuitedNumber(Suit.Rockets, 4), new SuitedNumber(Suit.Blue, 5)],
      //hinted: [new SuitedNumber(Suit.Blue, 5), Hint.Only],
      hinted: null
    };
  }

  render() {
    let unplayedCards = this.props.cards.filter(
      card => !this.state.played.some(played => equal(played, card))
    );

    let hintableCards: SuitedNumber[] = [];
    if (this.state.hinted === null) {
      const grouped = groupBy(unplayedCards, "suit");
      delete grouped.rockets;
      for (const [suit, cards] of Object.entries(grouped)) {
        // @ts-ignore
        if (cards.length === 1) {
          // @ts-ignore
          hintableCards.push(cards[0]);
        } else {
          // @ts-ignore
          let sorted = cards.sort((l, r) => l.number < r.number);
          hintableCards.push(sorted[0]);
          hintableCards.push(sorted[sorted.length - 1]);
        }
      }
    }

    const cards = unplayedCards.map((card, index) => {
      let hintForCard = Hint.None;
      if (this.state.hinted) {
        const [hintedCard, hint] = this.state.hinted;
        if (equal(hintedCard, card)) {
          hintForCard = hint;
        }
      }
      let canHint = hintableCards.some(hintable => equal(hintable, card));
      return (
        <Card
          size={Size.Large}
          number={card.number}
          suit={card.suit}
          hint={hintForCard}
          canHint={canHint}
          key={index}
        />
      );
    });

    return <div className="hand">{cards}</div>;
  }
}
